export const types = Object.freeze({
  RESPONSE: 'response',
  REQUEST: 'request'
})
